import API from '../../services/API'
import {
    PROFILE_GETTER,
    PROFILE_MUTATION_SINGLE_ENTRY,
    PROFILE_MUTATION_ENTIRE_PROFILE,
    PROFILE_ACTION_GET_PROFILE,
    PROFILE_ACTION_SAVE_PROFILE
} from './profile-types'

import Vue from 'vue'
import OAlert from '../../utils/OAlert/OAlert'
import i18n from '../../assets/i18n/lang'

export default {
    namespaced: true,

    state: {
        profile: {}
    },

    getters: {
        [PROFILE_GETTER]: state => state.profile
    },

    mutations: {
        [PROFILE_MUTATION_SINGLE_ENTRY] (state, payload) {
            let key = Object.keys(payload)[0]
            Vue.set(state.profile, key, payload[key])
        },
        [PROFILE_MUTATION_ENTIRE_PROFILE] (state, payload) {
            if (payload['birthdate'] != null) payload['birthdate'] = new Date(payload['birthdate'] + 'T00:00:00Z')
            state.profile = payload
        }
    },

    actions: {
        [PROFILE_ACTION_GET_PROFILE] ({ commit }) {
            API.loadProfile()
                .then((profileData) => { commit(PROFILE_MUTATION_ENTIRE_PROFILE, profileData) })
                .catch((error) => console.log('' + error.message))
        },
        [PROFILE_ACTION_SAVE_PROFILE] ({commit, state}, payload) {
            API.saveProfile(payload)
                .then((profileData) => {
                    OAlert.showSuccess('', i18n.t('feedback.profileSucSave'))
                    commit(PROFILE_MUTATION_ENTIRE_PROFILE, profileData)
                })
                .catch((error) => console.log(error.message))
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js